import React from 'react'
import PropTypes from 'prop-types'
import Text from '#components/a/Text'
import Checkbox from '#components/a/form/Checkbox'

export function CheckboxWithTitledText({title, text, checked, onChangeHandle}) {
  return (
    <div data-testid={`checkbox-with-titled-text-${title}`} className="checkbox-with-titled-text">
      <Checkbox checked={checked} onChangeHandle={onChangeHandle} />
      <div className="checkbox-with-titled-text__texts">
        <Text text={title} />
        <Text modifier="darker" text={text} />
      </div>
    </div>
  )
}

CheckboxWithTitledText.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  checked: PropTypes.bool,
  onChangeHandle: PropTypes.func,
}

export default CheckboxWithTitledText
